import styled from '@emotion/styled';
import { BreakPoints } from '@triumph/design-system';
import { useAppContext } from '@/app/components/providers/AppContextProvider';

const StyledRow = styled.tr<StyledRowProps>`
    opacity: ${({ isLoading, breakpoint }) =>
        isLoading ? (breakpoint == BreakPoints.Xs ? `.05` : `.25`) : null};
    background-color: ${({ index, theme, isError, alternateRowColor }) =>
    isError ? (theme.colors.semantic.dangerSecondaryHover):
        (index % 2 === 0 && alternateRowColor) ? theme.colors.greyscale.gray2_5 : null }
`;

interface StyledRowProps extends TableRowProps {
    breakpoint: BreakPoints;
}

interface TableRowProps {
    children: any;
    index: number;
    isLoading?: boolean | undefined;
    isError?: boolean
    alternateRowColor: boolean
}

const TableRow: React.FC<TableRowProps> = ({ children, isLoading, index, isError, alternateRowColor}) => {
    const { breakpoint } = useAppContext();
    return (
        <StyledRow breakpoint={breakpoint} isLoading={isLoading} index={index} isError={isError} alternateRowColor={alternateRowColor ?? true}>
            {children}
        </StyledRow>
    );
};

export default TableRow;
